<template>
  <div id="topPayInfo" :key="scaleKey">
    <div class="bg-color-black">
      <!-- <div class="d-flex h10">
        <div class="d-flex assetsPieTitle">
          <span class="fs-xl text_title mx-2 commonTitle">鍖荤敤缁囩墿鏅鸿兘涓€浣撳寲绠＄悊涓績</span>
          <dv-decoration-3 class="dv-dec-3" />
        </div>
        <div class="getTime">{{getTime}}</div>
      </div> -->
      <div class="h90 top-content">
        <div class="top-content-left content-box">
          <div
            v-for="(item, index) in leftdata"
            :key="index"
            class="data-margin"
          >
            <div class="content-box-large box-img">
              <div class="border-box top-item-row">
                <!-- img -->
                <div class="content-box-large-left">
                  <img class="large-img" :src="item.img" alt="" />
                </div>
                <!-- 鏁伴噺/绫诲瀷 -->
                <div class="content-box-large-right">
                  <div class="top-content-count">
                    <span
                      :style="item.data.style"
                      :id="`radarAcount${item.key}`"
                      class="radar-content-count"
                      >{{ item.data.number }}</span
                    >
                  </div>
                  <div class="top-content-title">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top-content-center">
          <div class="">
            <CenterInfo :salaryAmtCount="salaryAmtCount" />
          </div>
        </div>
        <div class="top-content-right content-box">
          <div
            v-for="(item, index) in rightdata"
            :key="index"
            class="data-margin"
          >
            <div class="content-box-large box-img">
              <div class="border-box">
                <div class="content-box-large-left">
                  <img class="large-img" :src="item.img" alt="" />
                </div>
                <div class="content-box-large-right">
                  <div class="top-content-count">
                    <span
                      :style="item.data.style"
                      :id="`radarAcount${item.key}`"
                      class="radar-content-count"
                      >{{ item.key == "account" ? 25 : item.data.number }}</span
                    >
                  </div>
                  <div class="top-content-title">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from "@/utils/index";
import CenterInfo from "./centerInfo.vue";
import * as Api from "@/api/index.js";
import { getSpuWashCountYmd } from "@/api/index.js";

export default {
  name: "TopPayInfo",
  components: { CenterInfo },
  data() {
    return {
      setTime: null,
      timeFn: null,
      reloadTime: "",
      leftdata: [],
      rightdata: [],
      setInter: null,
      scaleKey: 1,
      first: true,
      salaryAmtCount: 0,
      getdata: null,
    };
  },
  mounted() {
    this.initTime();
    this.createData();
    this.setTime = setInterval(() => {
      this.createData();
    }, 30 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.setTime);
    clearInterval(this.timeFn);
    clearInterval(this.setInter);
  },
  methods: {
    initWH() {
      this.$nextTick(() => {
        this.scaleKey += 1;
        this.$forceUpdate();
      });
    },
    initTime() {
      this.timeFn = setInterval(() => {
        const date = new Date();
        this.reloadTime = formatTime(date.getTime(), "HH:mm:ss");
        if (this.reloadTime === "06:00:00") {
          window.location.reload();
        }
      }, 1000);
    },
    formatNumber(n) {
      const num = Number(n || 0);
      if (!Number.isFinite(num)) return "0";
      return num.toLocaleString("zh-CN");
    },
    random(data) {
      const arr = [
        data.totalAmount || 0,
        data.totalCount || 0,
        data.companyCount || 0,
        data.cityCount || 25,
      ];

      if (!this.getdata) this.getdata = arr;
      const keyMap = { 0: "grantSys", 1: "allpay", 2: "city", 3: "account" };

      arr.forEach((item, index) => {
        const key = keyMap[index];
        if (key === "account") return;
        const dom = document.getElementById(`radarAcount${key}`);
        if (!dom) return;

        const target = Number(item || 0);
        let current = this.first ? 0 : Number(this.getdata[index] || 0);
        const step = () => Math.max(1, Math.ceil(Math.abs(target - current) / 5));

        clearInterval(this.setInter);
        this.setInter = setInterval(() => {
          if (current === target) {
            clearInterval(this.setInter);
            this.first = false;
            return;
          }

          if (current > target) current = Math.max(target, current - step());
          else current = Math.min(target, current + step());

          dom.innerHTML = key === "allpay" ? this.formatNumber(current) : String(current);
        }, 30);
      });

      this.getdata = arr;
    },
    async createData() {
      try {
        const ymdResponse = await getSpuWashCountYmd();
        const ymdData = ymdResponse?.Result || {};

        await Api.getServiceStatMessage();

        const mappedData = {
          dayWashCount: ymdData.dayReceiveNum || 0,
          dayDeliveryCount: ymdData.dayDeliveryNum || 0,
          monthWashCount: ymdData.monthReceiveNum || 0,
          monthDeliveryCount: ymdData.monthDeliveryNum || 0,
          salaryAmtCount: ymdData.yearReceiveNum || 0,
        };

        const style = {
          fontSize: "19.2px",
          fontFamily: "PingFangSC-Medium",
          textAlign: "left",
        };

        this.salaryAmtCount = Number(mappedData.salaryAmtCount);

        this.leftdata = [
          {
            img: require("@/assets/hospital_bed.svg"),
            title: "日洗涤数量",
            key: "dayWash",
            data: { number: mappedData.dayWashCount, style: { ...style, color: "#23F0FD" } },
          },
          {
            img: require("@/assets/medical_staff.svg"),
            title: "日配送数量",
            key: "dayDelivery",
            data: { number: mappedData.dayDeliveryCount, style: { ...style, color: "#59BAFF" } },
          },
        ];

        this.rightdata = [
          {
            img: require("@/assets/grantSys.png"),
            title: "月洗涤数量",
            key: "monthWash",
            data: { number: mappedData.monthWashCount, style: { ...style, color: "#59BAFF" } },
          },
          {
            img: require("@/assets/xiyiji.svg"),
            title: "月配送数量",
            key: "monthDelivery",
            data: { number: mappedData.monthDeliveryCount, style: { ...style, color: "#23F0FD" } },
          },
        ];

        setTimeout(() => this.random(mappedData), 300);
      } catch (error) {
        console.error("获取数据失败:", error);
        const fallbackData = {
          dayWashCount: 0,
          dayDeliveryCount: 0,
          monthWashCount: 0,
          monthDeliveryCount: 0,
          salaryAmtCount: 0,
        };
        setTimeout(() => this.random(fallbackData), 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box-img-L {
  background: url("~@/assets/topBorder.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.top-content-center {
  display: block;
  flex: 0 0 50% !important;
  width: 50%;
  max-width: 50%;
  min-width: 0;
  overflow: visible;
  background: url("~@/assets/topBorder.png") no-repeat;
  background-position: center;
  // background-size: cover;
  background-size: 100% 100%;
  margin: 0 4px;
  padding: 4.32px 16px;
}
.box-img {
  background: url("~@/assets/topBorderL.png") no-repeat;
  background-position: center;
  background-size: contain;
}

#topPayInfo {
  border-radius: 10px;
  height: 100%;

  .bg-color-black {
    border-radius: 10px;
    height: 100%;
  }

  .h10 {
    height: 10%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 15.36px; // 0.8vw = 15.36px
    position: relative;
    top: 5.4px; // 0.5vh = 5.4px

    .assetsPieTitle {
      display: flex;
      align-items: center;
    }

    .commonTitle {
      color: #d3d6dd;
      font-size: 23.04px; // 1.2vw = 23.04px
      font-weight: 500;
      margin-right: 9.6px; // 0.5vw = 9.6px
    }

    .dv-dec-3 {
      position: relative;
      width: 96px; // 5vw = 96px
      height: 10.8px; // 1vh = 10.8px
      top: -2.16px; // -0.2vh = -2.16px
    }

    .getTime {
      font-size: 15.36px; // 0.8vw = 15.36px
      font-family: PingFangSC-Medium;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .h90 {
    height: 85%;
  }

  .top-content {
    color: #d3d6dd;
    position: relative;
    display: flex;
    justify-content: space-between;
    text-align: center;
    font-weight: 400;
    font-size: 15.36px; // 0.8vw = 15.36px
    padding: 3.24px; // 0.3vh = 3.24px
    height: 100%;

    &-title {
      font-family: PingFangSC-Medium;
      font-size: 13.44px; // 0.7vw = 13.44px
      text-align: center;
      color: #d3d6dd;
      margin-top: 3.24px; // 0.3vh = 3.24px
      width: max-content;
    }

    .data-margin {
      margin: 0 3px;
    }

    &-count {
      position: relative;
      display: flex;
      // justify-content: center;
      // margin: 0.3vh auto 0;
      font-size: 9.6px; // 0.5vw = 9.6px
      color: #00cdff;
      font-weight: 700;
      margin-bottom: 12px;
    }

        &-left {
          margin-left: 0;
          flex: 0 0 25%;
          width: 25%;
          max-width: 25%;

          > :first-child {
            margin-left: auto !important;
          }
    
    }

    &-right {
      min-width: 0;
      margin-left: 0;
      margin-right: 0;
      flex: 0 0 25%;
      width: 25%;
      max-width: 25%;
      justify-content: left;
    }

    .content-box {
      position: relative;
      display: flex;
      margin: 0;
      gap: 6px;
      align-items: center;
      flex: 1;

      &-large {
        width: 100%;
        // height: 6vh;

        &-left {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &-right {
          width: 100%;
          text-align: center;
          width: fit-content;
          margin-left: 6px;
        }

        .border-box {
          display: flex;
          flex-direction: row;
          position: relative;
          justify-content: center;
          align-items: center;
          width: 132px;
          height: 78px;

          img {
            position: relative;
            top: 0;
            left: 0;
            margin-bottom: 3.24px; // 0.3vh = 3.24px
          }
        }
      }
    }

    &-center {
      flex: 0 0 50%;
      width: 50%;
      max-width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 0;
    }
  }

  .large-img {
    width: 28.8px; // 1.5vw = 28.8px
    height: 28.8px; // 1.5vw = 28.8px
  }
  .top-item-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 >= 1520px
  @media screen and (max-width: 0px) and (min-width: 1520px) {
    .top-content {
      font-size: 14px;
      padding: 3px;

      &-title {
        font-size: 12px;
        margin-top: 3px;
      }

      &-count {
        font-size: 9px;
        margin-bottom: 10px;
      }

      &-center {
        margin: 0 8px;
        padding: 4px 24px;
      }

      .data-margin {
        margin: 0 5px;
      }

      &-left {
        margin-left: 5px;
      }

      &-right {
        min-width: 80px;
        margin-left: 5px;
        margin-right: 8px;
      }

      .content-box {
        margin: 0 5px;

        &-large {
          .border-box {
            width: 160px;
            height: 96px;

            img {
              margin-bottom: 3px;
            }
          }

          &-right {
            margin-left: 10px;
          }
        }
      }
    }

    .large-img {
      width: 24px;
      height: 24px;
    }

    .h10 {
      padding: 0 12px;
      top: 5px;

      .commonTitle {
        font-size: 20px;
        margin-right: 8px;
      }

      .dv-dec-3 {
        width: 80px;
        height: 10px;
        top: -2px;
      }

      .getTime {
        font-size: 14px;
      }
    }
  }

  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 >= 1400px 涓?< 1520px
  @media screen and (max-width: 0px) and (min-width: 1400px) and (max-width: 1519px) {
    .top-content {
      font-size: 12px;
      padding: 2.5px;

      &-title {
        font-size: 10px;
        margin-top: 2.5px;
      }

      &-count {
        font-size: 8px;
        margin-bottom: 8px;
      }

      &-center {
        margin: 0 7px;
        padding: 3.5px 20px;
      }

      .data-margin {
        margin: 0 4px;
      }

      &-left {
        margin-left: 4px;
      }

      &-right {
        min-width: 70px;
        margin-left: 4px;
        margin-right: 7px;
      }

      .content-box {
        margin: 0 4px;

        &-large {
          .border-box {
            width: 140px;
            height: 84px;

            img {
              margin-bottom: 2.5px;
            }
          }

          &-right {
            margin-left: 8px;
          }
        }
      }
    }

    .large-img {
      width: 21px;
      height: 21px;
    }

    .h10 {
      padding: 0 11px;
      top: 4px;

      .commonTitle {
        font-size: 17px;
        margin-right: 7px;
      }

      .dv-dec-3 {
        width: 70px;
        height: 8px;
        top: -1.5px;
      }

      .getTime {
        font-size: 12px;
      }
    }
  }

  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 < 1400px
  @media screen and (max-width: 0px) and (max-width: 1399px) {
    .top-content {
      font-size: 10px;
      padding: 2px;

      &-title {
        font-size: 9px;
        margin-top: 2px;
      }

      &-count {
        font-size: 7px;
        margin-bottom: 6px;
      }

      &-center {
        margin: 0 6px;
        padding: 3px 16px;
      }

      .data-margin {
        margin: 0 3px;
      }

      &-left {
        margin-left: 3px;
      }

      &-right {
        min-width: 60px;
        margin-left: 3px;
        margin-right: 6px;
      }

      .content-box {
        margin: 0 3px;

        &-large {
          .border-box {
            width: 120px;
            height: 72px;

            img {
              margin-bottom: 2px;
            }
          }

          &-right {
            margin-left: 6px;
          }
        }
      }
    }

    .large-img {
      width: 18px;
      height: 18px;
    }

    .h10 {
      padding: 0 9px;
      top: 3px;

      .commonTitle {
        font-size: 14px;
        margin-right: 6px;
      }

      .dv-dec-3 {
        width: 60px;
        height: 7px;
        top: -1px;
      }

      .getTime {
        font-size: 10px;
      }
    }
  }

  // 1280 * 680 special fit
  @media screen and (max-width: 0px) and (max-width: 1280px) and (max-height: 700px) {
    .top-content-left {
      flex: 0 0 22% !important;
      width: 22%;
      max-width: 22%;
    }

    .top-content-right {
      flex: 0 0 22% !important;
      width: 22%;
      max-width: 22%;
    }

    .top-content {
      padding: 0 2px;
      justify-content: space-between;

      .top-content-count {
        margin-bottom: 4px;
      }

      .radar-content-count {
        font-size: 16px !important;
        line-height: 1;
      }

      .top-content-title {
        font-size: 11px;
        line-height: 1.1;
      }

      &-left,
      &-right {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &-center {
        flex: 0 0 56% !important;
        width: 56%;
        max-width: 56%;
        margin: 0 2px;
        padding: 1px 4px;
      }

      .content-box {
        margin: 0;
        gap: 8px;

        &-large {
          width: 100%;
          .border-box {
            width: 100% !important;
            height: 79px;
            overflow: hidden;
          }

          &-right {
            margin-left: 3px;
            min-width: 0;
          }
        }
      }

      .data-margin {
        margin: 0 !important;
        flex: 1 1 0;
        min-width: 0;
      }
    }

    .top-content-center {
      overflow: visible;
    }

    .large-img {
      width: 22px;
      height: 22px;
    }
  }

  // 1280 * 600 special fit: enlarge side cards a bit
  @media screen and (max-width: 0px) and (max-width: 1280px) and (max-height: 620px) {
    .top-content {
      .radar-content-count {
        font-size: 20px !important;
      }

      .top-content-title {
        font-size: 14px;
      }

      .content-box {
        &-large {
          .border-box {
            width: 100% !important;
            height: 88px;
          }
        }
      }
    }

    .large-img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>


